// carousels logic
const npdp_swiper_thumbs = new Swiper(".npdp-thumbs-swiper", {
  slidesPerView: 4,
  direction: "vertical"
});

const npdp_swiper_gallery = new Swiper(".npdp-swiper", {
  loop: true,
  navigation: {
    nextEl: ".npdp-gallery .gallery-next",
    prevEl: ".npdp-gallery .gallery-prev",
  },
  pagination: {
    el: ".npdp-gallery .swiper-pagination",
    renderBullet: function (index, className) {
      return '<div class="' + className + '"></div>';
    }
  },
  thumbs: {
    swiper: npdp_swiper_thumbs,
  },
  /* breakpoints: {
    769: {
    }
  } */
});

document.querySelector('.npdp-thumbs .thumb-next')?.addEventListener("click", () => {
  npdp_swiper_gallery.slideNext();
});

document.querySelector('.npdp-thumbs .thumb-prev')?.addEventListener("click", () => {
  npdp_swiper_gallery.slidePrev();
});
// Variants logic
/* const color = 
const option =
const option2 = */
const addZoomToGallery = _ => {
  npdp_swiper_gallery.slides.forEach(slide => {
    if (!slide.classList.contains('npdp-video') || !slide.classList.contains('npdp-iframe')) {
      slide.addEventListener("click", e => {
        let galleryMedia = []
        npdp_swiper_gallery.slides.forEach(media => {
          galleryMedia = [...galleryMedia, media.querySelector("[data-file], video, iframe")]
        })
        $s.photoSwipe(galleryMedia, slide.querySelector("[data-file]"));
      })
    }
  })
}

const normalizeAltValue = (val) => {
  if (!val) return "";
  return val.trim()
    .replace(/[,\/\+\s]+/g, "[,\\/\\+\\s]+");
}

const updateCarouselImages = _ => {
  const allImages = document.querySelector(".npdp-gallery-data");
  if (!allImages) return;

  const checkedOption = document.querySelector("form#new_pdp_form .colors input[name='color']:checked");
  const checkedLetter = document.querySelector("form#new_pdp_form .option[data-name='Initial'] select");
  const checkedMonth = document.querySelector(
  "form#new_pdp_form .option[data-name='Month'] select"
);
  const checkedGemstone = document.querySelector("form#new_pdp_form .option[data-name='Gemstone'] select");
  const checkedDiamond = document.querySelector("#variant_Diamond_Stud_Setting_Type option:checked");

  const checkedSettingTypeOpt = document.querySelector("#variant_Setting_Type option:checked");
  const settingTypeValue = checkedSettingTypeOpt?.value?.trim() || "";

  const rebuildSwipers = (gallerySlides, thumbsSlides) => {
    npdp_swiper_thumbs.removeAllSlides();
    npdp_swiper_gallery.removeAllSlides();

    gallerySlides.forEach((slide, index) => {
      const newSlide = slide.cloneNode(true);
      if (index === 0) newSlide.querySelector("img")?.setAttribute("loading", "eager");
      npdp_swiper_gallery.appendSlide(newSlide);
    });

    thumbsSlides.forEach((slide, index) => {
      const newSlide = slide.cloneNode(true);
      if (index === 0) newSlide.querySelector("img")?.setAttribute("loading", "eager");
      npdp_swiper_thumbs.appendSlide(newSlide);
    });

    npdp_swiper_gallery.update();
    npdp_swiper_thumbs.update();

    const thumbsWrapper = document.querySelector(".npdp-thumbs-swiper");
    const slides = thumbsWrapper?.querySelectorAll(".swiper-wrapper .swiper-slide") || [];
    thumbsWrapper?.classList.toggle("few-thumbs", slides.length <= 4);

    addZoomToGallery();
  };

  const getAltOrder = (alt) => {
    const match = (alt || "").match(/-(\d+)\^/);
    return match ? parseInt(match[1], 10) : 999;
  };


  if (!checkedOption) {
    const galleryAll = allImages.querySelectorAll(
      `.gallery-data > .swiper-slide, .gallery-data > .swiper-slide.npdp-video, .gallery-data > .swiper-slide.npdp-iframe`
    );
    const thumbsAll = allImages.querySelectorAll(
      `.thums-data > .swiper-slide, .thums-data > .swiper-slide.npdp-video, .thums-data > .swiper-slide.npdp-iframe`
    );
    rebuildSwipers(Array.from(galleryAll), Array.from(thumbsAll));
    return;
  }

  const altRegex = new RegExp(normalizeAltValue(checkedOption.value), "i");

  const matchesExtraFilters = (alt) => {

    let ok = true;
    if (checkedGemstone?.value) ok = ok && alt.includes(checkedGemstone.value);

    if (settingTypeValue) ok = ok && alt.includes(settingTypeValue);
    return ok;
  };

  const galleryCandidates = Array.from(allImages.querySelectorAll(
    `.gallery-data > .swiper-slide, .gallery-data > .swiper-slide.npdp-video, .gallery-data > .swiper-slide.npdp-iframe`
  ));

  const thumbsCandidates = Array.from(allImages.querySelectorAll(
    `.thums-data > .swiper-slide, .thums-data > .swiper-slide.npdp-video, .thums-data > .swiper-slide.npdp-iframe`
  ));

  let galleryImages = galleryCandidates.filter(slide => {
    if (slide.classList.contains("npdp-video") || slide.classList.contains("npdp-iframe")) return true;
    const alt = slide.getAttribute("data-alt") || "";
    return altRegex.test(alt) && matchesExtraFilters(alt);
  });

  let thumbsImages = thumbsCandidates.filter(slide => {
    if (slide.classList.contains("npdp-video") || slide.classList.contains("npdp-iframe")) return true;
    const alt = slide.getAttribute("data-alt") || "";
    return altRegex.test(alt) && matchesExtraFilters(alt);
  });

  if (galleryImages.length === 0 || thumbsImages.length === 0) {
    galleryImages = galleryCandidates.filter(slide => {
      if (slide.classList.contains("npdp-video") || slide.classList.contains("npdp-iframe")) return true;
      const alt = slide.getAttribute("data-alt") || "";
      let match = altRegex.test(alt);
      if (checkedGemstone?.value) match = match && alt.includes(checkedGemstone.value);
      return match;
    });

    thumbsImages = thumbsCandidates.filter(slide => {
      if (slide.classList.contains("npdp-video") || slide.classList.contains("npdp-iframe")) return true;
      const alt = slide.getAttribute("data-alt") || "";
      let match = altRegex.test(alt);
      if (checkedGemstone?.value) match = match && alt.includes(checkedGemstone.value);
      return match;
    });
  }

  galleryImages.sort((a, b) => {
    if (a.classList.contains("npdp-video") || a.classList.contains("npdp-iframe")) return 1;
    if (b.classList.contains("npdp-video") || b.classList.contains("npdp-iframe")) return -1;
    return getAltOrder(a.dataset.alt) - getAltOrder(b.dataset.alt);
  });

  thumbsImages.sort((a, b) => {
    if (a.classList.contains("npdp-video") || a.classList.contains("npdp-iframe")) return 1;
    if (b.classList.contains("npdp-video") || b.classList.contains("npdp-iframe")) return -1;
    return getAltOrder(a.dataset.alt) - getAltOrder(b.dataset.alt);
  });

  npdp_swiper_thumbs.removeAllSlides();
  npdp_swiper_gallery.removeAllSlides();

  galleryImages.forEach((slide, index) => {
    const newSlide = slide.cloneNode(true);
    if (index === 0) newSlide.querySelector("img")?.setAttribute("loading", "eager");

    if (checkedLetter) {
      if (slide.dataset.alt && slide.dataset.alt.includes(`,${checkedLetter.value}`)) {
        npdp_swiper_gallery.appendSlide(newSlide);
      } else if (slide.dataset.alt && !slide.dataset.alt.includes(",")) {
        npdp_swiper_gallery.appendSlide(newSlide);
      }

    } else if (checkedMonth) {
      if (slide.dataset.alt && slide.dataset.alt.includes(checkedMonth.value)) {
        npdp_swiper_gallery.appendSlide(newSlide);
      }
    } else {
      npdp_swiper_gallery.appendSlide(newSlide);
    }
  });

  thumbsImages.forEach((slide, index) => {
    const newSlide = slide.cloneNode(true);
    if (index === 0) newSlide.querySelector("img")?.setAttribute("loading", "eager");

    if (checkedLetter) {
      if (slide.dataset.alt && slide.dataset.alt.includes(`,${checkedLetter.value}`)) {
        npdp_swiper_thumbs.appendSlide(newSlide);
      } else if (slide.dataset.alt && !slide.dataset.alt.includes(",")) {
        npdp_swiper_thumbs.appendSlide(newSlide);
      }
    } else if (checkedMonth) {
      if (slide.dataset.alt && slide.dataset.alt.includes(checkedMonth.value)) {
        npdp_swiper_thumbs.appendSlide(newSlide);
      }
    } else {
      npdp_swiper_thumbs.appendSlide(newSlide);
    }
  });

  if (checkedDiamond) {
    galleryImages.forEach((slide, index) => {
      if (!slide.dataset.alt?.includes(`${checkedDiamond.value}`)) return;
      npdp_swiper_gallery.slideTo(index);
    });
    thumbsImages.forEach((slide, index) => {
      if (!slide.dataset.alt?.includes(`${checkedDiamond.value}`)) return;
      npdp_swiper_thumbs.slideTo(index);
    });
  }

  const thumbsWrapper = document.querySelector(".npdp-thumbs-swiper");
  const slides = thumbsWrapper?.querySelectorAll(".swiper-wrapper .swiper-slide") || [];
  thumbsWrapper?.classList.toggle("few-thumbs", slides.length <= 4);

  npdp_swiper_gallery.update();
  npdp_swiper_thumbs.update();
  addZoomToGallery();
};


updateCarouselImages()

// utils functions

function updateURLParam(key, value) {
  var baseUrl = [location.protocol, '//', location.host, location.pathname].join(''), urlQueryString = document.location.search, newParam = key + '=' + value, params = '?' + newParam;
  if (urlQueryString) {
    let keyRegex = new RegExp('([\?&])' + key + '[^&]*');
    if (urlQueryString.match(keyRegex) !== null)
      params = urlQueryString.replace(keyRegex, "$1" + newParam);
    else
      params = urlQueryString + '&' + newParam;
  }
  window.history.replaceState({}, "", baseUrl + params);
}

function updateWLStyle(sku) {
  const wlEl = document.querySelector(".wl-style");
  if (wlEl) {
    wlEl.textContent = `( ${sku} )`;
  }
}


const firstVariant = variant_id.selectedOptions[0]
let currentVariant = {
  id: variant_id.value,
  title: firstVariant.dataset.title,
  src: firstVariant.dataset.src,
  price: +firstVariant.dataset.price / 100
}

window.CurrentVnt = currentVariant;

const updateVariant = (updateGallery, isColor, value) => {
  //if (updateGallery) {
    setTimeout(() => {
         updateCarouselImages() 
    }, 100);
  //}
  if (isColor && !document.querySelector("#variant_Price")) {
    document.querySelectorAll("form#new_pdp_form .option:not(.opt-extra) select").forEach((select, index) => {
      const currentValue = select.value;
      const optionsSelect = select.querySelectorAll("option");
      let realOptions = [];
      variant_id.querySelectorAll(`option[data-option1='${value}']`).forEach(option => {
        realOptions = [...realOptions, option.dataset[`option${index + 2}`]];
      });

      optionsSelect.forEach(option => {
        if (realOptions.some(realOpt => realOpt == option.value)) {
          option.removeAttribute("hidden");
        } else {
          option.setAttribute("hidden", true);
        }
      });

      const currentOptionStillAvailable = select.querySelector(`option[value="${currentValue}"]:not([hidden])`);

      if (currentOptionStillAvailable) {
        select.value = currentValue;
      } else {
        select.querySelector("option:not([hidden])").selected = true;
      }
    });
  }
  let options = []
  document.querySelectorAll('form#new_pdp_form .option:not(.opt-extra)').forEach(option => {
    const optValue = option.querySelector(".colors") ? option.querySelector("input[name='color']:checked")?.value : option.querySelector("select")?.value
    options = [...options, [option.dataset.name, optValue]]
  })
  const query = options.reduce((acc, option, index) => acc += `[data-option${index + 1}="${option[1]}"]`, "")
  const selectedOption = variant_id.querySelector(`option${query}`)
  const notifyBtn = document.querySelector(".notify-btn")
  const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
  const sticky_atc_btn = document.querySelector(".sticky-atc-v2 button")
  const sticky_terms_btn = document.querySelector(".sticky-atc-v2 a.terms-btn")
  const input_lt = document.querySelector('form#new_pdp_form input[name="properties[Lead Time]"]')
  const product_price = document.querySelector(".new-pdp-layout #npdp_price")
  const engravingEl = document.querySelector("product-engraving");
  
  const ea_block = document.querySelector(".estimated-arrival-block")
  input_lt.value = selectedOption.dataset.leadTime
  if (ea_block) {
    if (selectedOption.dataset.leadTime === 'Ready to Ship!' || selectedOption.dataset.leadTime === 'Only 1 Left') {
        ea_block.style.display = ""
        ea_block.closest(".extra-info")?.classList.remove("ea-hidden")
    } else {
        ea_block.style.display = "none"
        ea_block.closest(".extra-info")?.classList.add("ea-hidden")
    }
  }

  if (selectedOption.dataset.leadTime != "" && selectedOption.dataset.leadTime !== 'Ready to Ship!' && selectedOption.dataset.leadTime !== 'Only 1 Left') {
    input_lt.removeAttribute("disabled")
  } else {
    input_lt.setAttribute("disabled", "true")
  }
  if (selectedOption.dataset.leadTime.includes("Notify")) {
    lt_con.style.display = "none"
    notifyBtn.classList.remove("hide")
    atc_btn.classList.add("hide")
    if (sticky_atc_btn) {
      sticky_atc_btn.classList.add("disabled")
    }
    if (
      engravingEl &&
      engravingEl.hasAttribute("data-engraving-product") &&
      engravingEl.hasAttribute("data-engraving-variant")
    ) {
      engravingEl.style.opacity = "0.5";
      engravingEl.style.pointerEvents = "none";
    }
  } else if (selectedOption.dataset.leadTime == "") {
    lt_con.style.display = "none"
    notifyBtn.classList.add("hide")
    atc_btn.classList.remove("hide")
    if (sticky_atc_btn && sticky_atc_btn.classList.contains("disabled")) {
      sticky_atc_btn.classList.remove("disabled")
    }
    if (engravingEl &&
      engravingEl.hasAttribute("data-engraving-product") &&
      engravingEl.hasAttribute("data-engraving-variant")) {
      engravingEl.style.opacity = "";
      engravingEl.style.pointerEvents = "";
    }
  } else {
    lt_con.style.display = "flex"
    notifyBtn.classList.add("hide")
    atc_btn.classList.remove("hide")
    if (sticky_atc_btn && sticky_atc_btn.classList.contains("disabled")) {
      sticky_atc_btn.classList.remove("disabled")
    }
    ship_time.textContent = selectedOption.dataset.leadTime
    if (engravingEl &&
      engravingEl.hasAttribute("data-engraving-product") &&
      engravingEl.hasAttribute("data-engraving-variant")) {
      engravingEl.style.opacity = "";
      engravingEl.style.pointerEvents = "";
    }
  }

  if (window["final_sale"] && window["final_sale"].checked == false) {
    if (sticky_atc_btn) {
      sticky_atc_btn.classList.add("hide")
    }

    if (sticky_terms_btn){  
      sticky_terms_btn.classList.remove("hide")
    }
    /* sticky_atc_btn.classList.add("disabled") */
  }
  
  updateURLParam('variant', selectedOption.value)
  variant_id.value = selectedOption.value
  // sticky atc update logic
  if (window["atc_img"]) {
    atc_img.src = selectedOption.dataset.src.replace("width=1000", "width=200")
  }
  if (window["atc_color"]) {
    atc_color.value = selectedOption.dataset.option1
  }
  if (window["atc_variants"]) {
    atc_variants.value = selectedOption.dataset.option2
  }
  // end sticky logic

  updateWLStyle(selectedOption.dataset.sku);

  currentVariant = {
    id: variant_id.value,
    title: selectedOption.dataset.title,
    option1: selectedOption.dataset.option1 || null,
    option2: selectedOption.dataset.option2 || null,
    option3: selectedOption.dataset.option3 || null,
    src: selectedOption.dataset.src,
    price: +selectedOption.dataset.price / 100
  }
  if (typeof _swat !== 'undefined') _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);

  // Update price display — respects sale pricing if active
  const pricesContainer = document.querySelector('.new-pdp-layout .npdp-prices');
  const saleActive = pricesContainer?.dataset.saleActive === 'true';
  const saleDiscount = saleActive ? parseFloat(pricesContainer.dataset.saleDiscount || '0') : 0;

  if (saleActive && saleDiscount > 0) {
    const rawPrice = currentVariant.price; // in dollars
    const discountedPrice = rawPrice * (1 - saleDiscount / 100);

    // Format like Shopify's money_without_trailing_zeros:
    // show decimals only when cents are non-zero
    const formatMoney = (dollars) => {
      const cents = Math.round(dollars * 100);
      if (cents % 100 === 0) {
        return `$${new Intl.NumberFormat('en-US').format(cents / 100)}`;
      }
      return `$${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100)}`;
    };

    product_price.textContent = formatMoney(discountedPrice);
    // Also update the original/strikethrough price
    const originalPriceEl = document.querySelector('.new-pdp-layout .npdp-original-price');
    if (originalPriceEl) {
      originalPriceEl.textContent = formatMoney(rawPrice);
    }
  } else {
    product_price.textContent = `$${new Intl.NumberFormat('en-US').format(currentVariant.price)}`;
  }

  window.CurrentVnt = currentVariant;


  
}

const defaultStockVariant = () => {

  const allInputs = document.querySelectorAll(
    "form#new_pdp_form .option:not(.opt-extra) select, form#new_pdp_form .option:not(.opt-extra) input[type='radio']"
  );
  const variantSelect = document.querySelector("#variant_id");

  if (!allInputs.length || !variantSelect) return;

  const metalColorInput = Array.from(allInputs).find(input =>
    input.closest(".option")?.dataset.name?.toLowerCase().includes("metal")
  );

  let selectedMetalColor = null;

  if (metalColorInput?.type === "radio") {
    const radios = document.querySelectorAll(`input[name='${metalColorInput.name}']`);
    const checked = Array.from(radios).find(r => r.checked);
    selectedMetalColor = checked?.value;
  } else if (metalColorInput?.type === "select-one") {
    selectedMetalColor = metalColorInput.value;
  }

  if (!selectedMetalColor) return;

  const matchingVariants = Array.from(variantSelect.options).filter(opt =>
    opt.dataset.option1 === selectedMetalColor
  );

  const readyToShipVariant = matchingVariants.find(opt =>
    opt.dataset.leadTime === "Ready to Ship!"
  );

  if (!readyToShipVariant) return;

  const optionCount = parseInt(variantSelect.dataset.options || "2", 10);

  for (let i = 1; i <= optionCount; i++) {
    const optionValue = readyToShipVariant.dataset[`option${i}`];
    const select = Array.from(document.querySelectorAll("form#new_pdp_form .option:not(.opt-extra) select")).find(
      s => s.closest(".option")?.dataset.name?.toLowerCase().includes(`option${i}`.toLowerCase()) || true
    );

    if (select && optionValue) {
      const optionToSelect = Array.from(select.options).find(o => o.value === optionValue);
      if (optionToSelect) {
        select.value = optionValue;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }
};



// set correct options  first time
setTimeout(_ => {
  updateVariant(false, true, document.querySelector("form#new_pdp_form input[name='color']:checked")?.value)
  defaultStockVariant()

  if (document.querySelector("#variant_Price")) {
      const price = document.querySelector("#npdp_price")

      price.textContent = currentVariant.price.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
  }

}, 0)

document.querySelectorAll("form#new_pdp_form .option:not(.opt-extra) select, form#new_pdp_form .option:not(.opt-extra) input[type='radio']").forEach(input => {
  input.addEventListener("change", e => {
    const isColor = e.target.closest(".colors")
    const isGemstone = e.target.dataset.name == "Gemstone"

    updateVariant(
      isColor || e.target.dataset.name == "Initial" || isGemstone,
      isColor,
      e.target.value
    )

    if (document.querySelector("#variant_Price")) {
      const price = document.querySelector("#npdp_price")

      price.textContent = currentVariant.price.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })
    }
      getVariantInventoryMessage(currentVariant)
      printInventoryInOptions(currentVariant)
      updateGemstoneAvailability(currentVariant);
  })
})

// Low Inventory logic

function getVariantInventoryMessage(variant) {

  const dataScript = document.getElementById('variants-inventory-data');

  if (!dataScript || !variant || !variant.id) return;
  let data;
  try {
    data = JSON.parse(dataScript.textContent);
  } catch (e) {
    return;
  }
  const variants = Array.isArray(data.variants) ? data.variants : data;
  const lowInventoryMessage = data.low_inventory_message || 'Low inventory';
  const lastUnitMessage = data.last_unit_message || '1 unit left';
  const found = variants.find(v => String(v.id) === String(variant.id));
  if (!found) return;
  
  let message = '';
  if (found.inventory_quantity == 1) {
    message = lastUnitMessage;
  } else if (found.inventory_quantity == 2 || found.inventory_quantity == 3) {
    message = lowInventoryMessage;
  }
  const el = document.querySelector('.low-in-stock');
  if (el) el.textContent = message;
}

function printInventoryInOptions(variant) {
  const dataScript = document.getElementById('variants-inventory-data');
  if (!dataScript || !variant || !variant.title) return;
  let data;
  try { data = JSON.parse(dataScript.textContent); }
  catch (e) { return; }
  if (!data.variants || !Array.isArray(data.variants)) return;

  const option1ToMatch = variant.option1 ? variant.option1.trim() : "";
  const option2ToMatch = variant.option2 ? variant.option2.trim() : "";
  const option3ToMatch = variant.option3 ? variant.option3.trim() : "";

  const normalizeSize = s => (s || '').replace(/[^0-9A-Za-z]/g, '').replace('-', '/').toUpperCase();

  const selects = document.querySelectorAll('select[class^="variant-select-"]');
  if (!selects.length) return;

  
  selects.forEach(selectEl => {
    selectEl.querySelectorAll('option').forEach(opt => {
      const base = opt.getAttribute('data-base-label') || (opt.value || '').trim();
      if (!opt.hasAttribute('data-base-label')) {
        opt.setAttribute('data-base-label', base);
      }

      const optionValue = (opt.value || '').trim();
      let matchedVariant;

      if (option3ToMatch) {
        matchedVariant = data.variants.find(v =>
          v.option1 && v.option2 && v.option3 &&
          v.option1.trim() === option1ToMatch &&
          normalizeSize(v.option2) === normalizeSize(option2ToMatch) &&
          normalizeSize(v.option3) === normalizeSize(optionValue)
        );
      } else if (option2ToMatch) {
        matchedVariant = data.variants.find(v =>
          v.option1 && v.option2 &&
          v.option1.trim() === option1ToMatch &&
          normalizeSize(v.option2) === normalizeSize(optionValue)
        );
      } else {
        matchedVariant = data.variants.find(v =>
          v.option1 && v.option2 &&
          v.option1.trim() === option1ToMatch &&
          normalizeSize(v.option2) === normalizeSize(optionValue)
        );
      }

      let message = '';

      if (matchedVariant) {
        const q = Number(matchedVariant.inventory_quantity);
        const bodyHasClass = document.body.classList.contains('apply-for-oos');

        if (bodyHasClass) {
          if (q == 0) {
            opt.disabled = true;
            opt.hidden = true;
            opt.textContent = base;
            opt.setAttribute('data-inventory-quantity', matchedVariant.inventory_quantity);
            return;
          } else {
            opt.disabled = false;
            opt.hidden = false;
          }
        }
        
        if (opt.hasAttribute('data-inventory-quantity')) {
          opt.setAttribute('data-inventory-quantity', matchedVariant.inventory_quantity);
        }

        message = matchedVariant.lead_time || '';
        opt.textContent = message ? `${base} - ${message}` : base;
        
      } else {
        if (opt.hasAttribute('data-inventory-quantity')) {
          opt.removeAttribute('data-inventory-quantity');
        }
        opt.disabled = false;
        opt.hidden = false;
      }

      if (message) {
        opt.setAttribute('data-lead-time', message);
      } else {
        opt.removeAttribute('data-lead-time');
      }
    });
  });
}

function updateGemstoneAvailability(variant) {
  const dataScript = document.getElementById('variants-inventory-data');
  if (!dataScript || !variant) return;
  let data;
  try { data = JSON.parse(dataScript.textContent); } catch (e) { return; }
  if (!data.variants || !Array.isArray(data.variants)) return;

  const option1ToMatch = variant.title.split('/')[0].trim();
  const normalize = s => (s || '').replace(/[^0-9A-Za-z/]/g, '').toUpperCase();

  const gemstoneSelect = document.querySelector("form#new_pdp_form .option[data-name='Gemstone'] select");
  if (!gemstoneSelect) return;

  Array.from(gemstoneSelect.options).forEach(opt => {
    const gemstoneValue = (opt.value || '').trim();
    const exists = data.variants.some(v =>
      v.option1 && v.option2 &&
      normalize(v.option1) === normalize(option1ToMatch) &&
      normalize(v.option2) === normalize(gemstoneValue)
    );
    if (!exists) {
      opt.setAttribute('data-no-available', 'true');
      opt.disabled = true;
      opt.hidden = true;
      opt.style.display = "none";
    } else {
      opt.removeAttribute('data-no-available');
      opt.disabled = false;
      opt.hidden = false;
      opt.style.display = "";
    }
  });
}

setTimeout(() => {
  getVariantInventoryMessage(currentVariant)
  printInventoryInOptions(currentVariant)
  updateGemstoneAvailability(currentVariant);

  updateWLStyle(document.querySelector("#variant_id option:checked")?.dataset.sku);
}, 300);

const isExchangeOnly = document.querySelector('input#exchange-only');

function toggleEngravingButtons(condition) {
  const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
  const sticky_atc_btn = document.querySelector(".sticky-atc-v2 button")
  const sticky_terms_btn = document.querySelector(".sticky-atc-v2 a.terms-btn")

  atc_btn.classList.toggle("disabled", condition)
  sticky_atc_btn.classList.toggle("hide", condition)
  sticky_terms_btn.classList.toggle("hide", condition)
}

document.querySelector("form#new_pdp_form .input-engraving #engraving_box")?.addEventListener("change", e => {
  document.querySelector(".npdp-engraving .e-con").classList.toggle("disabled")
  document.querySelector(".npdp-engraving .e-final-sale").classList.toggle("hide")
  document.querySelectorAll(".npdp-engraving .e-final-sale input, .npdp-engraving input#engraving_text, .npdp-engraving .engraving-inputs input").forEach(input => {
    if (!e.target.checked) {
      input.setAttribute("disabled", "true")
    } else {
      input.removeAttribute("disabled")
    }
  })

  if (isExchangeOnly) isExchangeOnly.closest(".exchange-only").classList.toggle("hide", e.target.checked);

  if (e.target.checked) {
    toggleEngravingButtons(!document.querySelector(".npdp-engraving .e-final-sale input").checked)
  } else {
    toggleEngravingButtons(!document.querySelector(".npdp-engraving .e-final-sale input").checked)
    if (isExchangeOnly) {
      toggleEngravingButtons(!isExchangeOnly.checked)
    }
  }

  // !document.querySelector(".npdp-engraving .e-final-sale input").checked
})
document.querySelector('form#new_pdp_form .npdp-engraving input[type="text"][name="properties[Engraving]"]')?.addEventListener("change", e => {
  document.querySelector('form#new_pdp_form .npdp-engraving .engraving-inputs #engraving_2').value = e.target.value
})
document.querySelector("form#new_pdp_form input#final_sale")?.addEventListener("change", _ => {
  const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
  const sticky_atc_btn = document.querySelector(".sticky-atc-v2 button")
  const sticky_terms_btn = document.querySelector(".sticky-atc-v2 a.terms-btn")
  atc_btn?.classList.toggle("disabled")
  sticky_atc_btn?.classList.toggle("hide")
  if (sticky_terms_btn){
    sticky_terms_btn.classList.toggle("hide")
  }
  /* if (!atc_btn.classList.contains("hide")) {
    sticky_atc_btn.classList.toggle("disabled")
  } */
  /* atc_btn.setAttribute("disabled", "true") */
})
document.querySelector("form#new_pdp_form input#exchange-only")?.addEventListener("change", e => {
  const atc_btn = document.querySelector('form#new_pdp_form input[type="submit"]')
  const sticky_atc_btn = document.querySelector(".sticky-atc-v2 button")
  const sticky_terms_btn = document.querySelector(".sticky-atc-v2 a.terms-btn")
  atc_btn?.classList.toggle("disabled", !e.target.checked)
  sticky_atc_btn?.classList.toggle("hide", !e.target.checked)
  sticky_terms_btn?.classList.toggle("hide", !e.target.checked)
})
/* const event = new CustomEvent("variant_change", { detail: {}}); */

// form logic
const atc_form = document.querySelector("#new_pdp_form")
atc_form.addEventListener("submit", e => {
  e.preventDefault()
  const jewerlyServiceInputs = document.querySelectorAll('form#new_pdp_form .jewerly-inputs input[name*="properties[_bundle_id]"]')
  const engravingInputs = document.querySelectorAll('form#new_pdp_form .engraving-inputs input[name*="properties[_bundle_id]"]')
  if (jewerlyServiceInputs.length > 0 || engravingInputs.length > 0) {
    const bundleId = new Date().getTime()
    jewerlyServiceInputs.forEach(input => {
      input.value = bundleId
    })
  }
  if (engravingInputs.length > 0) {
    const bundleId = new Date().getTime()
    engravingInputs.forEach(input => {
      input.value = bundleId
    })
  }
  const formData = new FormData(atc_form)

  const variantId = formData.get("id")
  const invalidCollectionValue = atc_form.querySelector('input[name="has_invalid_tag"]').value === "true"

  if (!window.cartInvalidCollections) {
    window.cartInvalidCollections = []
  }

  const index = window.cartInvalidCollections.findIndex(obj => obj.id == variantId)
  if (index !== -1) {
    window.cartInvalidCollections[index].invalid_Collection = invalidCollectionValue
  } else {
    window.cartInvalidCollections.push({
      id: variantId,
      invalid_Collection: invalidCollectionValue
    })
  }

  $s.showLoadingOverlay()

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
    .then(response => {
      $s.hideLoadingOverlay()
      if (response.ok) {
        window.SideCart.updateSideCart(true)
      }
      return response.json()
    })
    .catch((error) => {
      $s.hideLoadingOverlay()
      console.error('Error:', error)
    })
})


// whist btn functionality

const product_id = +document.querySelector('form#new_pdp_form input[name="product-id"]').value
const wlBtnEl = document.querySelector(".wishlist-btn-new");

function swymCallbackFn() {
  if (typeof _swat !== 'undefined') _swat.fetchWrtEventTypeET(fetchCallbackFn, 4);

}
wlBtnEl.addEventListener('click', event => {
  SwymPageData.et = 4;	// et 4 stands for wishlist event type
  var swymPageData = {
    ...SwymPageData,
    empi: product_id,
    epi: currentVariant.id,
    pr: currentVariant.price / 100,
    iu: currentVariant.src
  }
  if (wlBtnEl.dataset.isInWishlist === 'true') {
    _swat.removeFromWishList(swymPageData, function (e) {
      wlBtnEl.classList.remove('saved')
      wlBtnEl.setAttribute('data-is-in-wishlist', 'false')
    });
  } else {
    _swat.addToWishList(swymPageData, function (e) {
      wlBtnEl.classList.add('saved');
      wlBtnEl.setAttribute('data-is-in-wishlist', 'true');
      createWLNotifyPopup(swymPageData, swymPageData.dt);
    });
  }
})
function createWLNotifyPopup(swymPageData, currentVariant) {
  let notifyPopup = document.createElement('div');
  notifyPopup.innerHTML = `
        <div class="flex align-items-start justify-content-between">
            <div class="one-third">
                <img src="${swymPageData.iu}" />
            </div>
            <div class="two-thirds">
                <div><strong>${swymPageData.dt} - ${currentVariant.title}</strong> has been added to your list.</div>
            </div>
        </div>`;
  notifyPopup.classList.add('wishlist-notify')
  document.body.appendChild(notifyPopup);
  setTimeout(() => {
    notifyPopup.remove()
  }, 4000)
}
function fetchCallbackFn(products) {
  var activeProductId = product_id, activeVariantId = currentVariant.id;
  var isInWishlist = products.find(function (p) {
    return p.empi == activeProductId && p.epi == activeVariantId;
  });
  if (isInWishlist) {
    wlBtnEl.classList.add('saved');
    wlBtnEl.setAttribute('data-is-in-wishlist', 'true');
  } else {
    wlBtnEl.classList.remove('saved');
    wlBtnEl.setAttribute('data-is-in-wishlist', 'false');
  }
}
if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

// extra functions

const changeJewerlyService = e => {
  document.querySelector("form#new_pdp_form .npdp-custom-select .drop-options .drop-option.selected").classList.remove("selected")
  const inputs = document.querySelectorAll("form#new_pdp_form .jewerly-inputs input")
  if (e.currentTarget.dataset.id == "none") {
    document.querySelector("form#new_pdp_form .npdp-custom-select .selected-opt > p").textContent = e.currentTarget.dataset.name
    inputs.forEach(input => {
      input.setAttribute("disabled", "true")
    })
  } else {
    document.querySelector("form#new_pdp_form .npdp-custom-select .selected-opt > p").innerHTML = `<div class="drop-color" style="--bg: ${e.currentTarget.dataset.color}"></div>${e.currentTarget.dataset.name}`
    document.querySelector('form#new_pdp_form .jewerly-inputs input[name="items[1][id]"]').value = e.currentTarget.dataset.id
    inputs.forEach(input => {
      input.removeAttribute("disabled")
    })
  }
  e.currentTarget.classList.add("selected")
  e.currentTarget.closest(".npdp-custom-select").classList.remove("open")
}
const customSelectJewerly = document.querySelector("form#new_pdp_form .npdp-custom-select")
if (customSelectJewerly) {
  window.addEventListener("click", e => {
    if (!e.composedPath().includes(customSelectJewerly) && customSelectJewerly.classList.contains("open")) {
      customSelectJewerly.classList.remove('open')
    }
  });
}


document.addEventListener("DOMContentLoaded", function () {
  const mainElement = document.querySelector(".new-pdp-layout");
  if (!mainElement) return;

  const productButtons = document.querySelector("[data-product-buttons]");
  if (!productButtons) return;

  const dynamicButtons = productButtons.querySelector(".shopify-payment-button");
  const mainAddButton = mainElement.querySelector(".btn.add");
  const localAddButton = productButtons.querySelector(".btn.add");

  if (localAddButton && localAddButton !== mainAddButton) {
    localAddButton.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (mainAddButton) mainAddButton.click();
    });
  }

  mainElement.addEventListener("variantChange", (e) => {
    const variant = e.detail?.variant;
    const requiredBtn = productButtons.querySelector(".btn.selection-required");
    const soldOutMsg = productButtons.querySelector(".sold-out-message");
    const addBtn = productButtons.querySelector(".btn.add");

    if (requiredOptionsExist()) {
      if (dynamicButtons) dynamicButtons.classList.add("hide");
      if (requiredBtn) {
        requiredBtn.style.display = "";
        requiredBtn.innerHTML = getRequiredMessage();
      }
    } else if (variant && variant.available) {
      if (dynamicButtons) dynamicButtons.classList.remove("hide");
      if (addBtn) {
        addBtn.style.display = "";
        if (soldOutMsg) soldOutMsg.style.display = "none";
        if (requiredBtn) requiredBtn.style.display = "none";
      }
    } else {
      if (dynamicButtons) dynamicButtons.classList.add("hide");
      if (addBtn) {
        addBtn.style.display = "none";
        if (soldOutMsg) soldOutMsg.style.display = "";
        if (requiredBtn) requiredBtn.style.display = "none";
      }
    }
  });

  function requiredOptionsExist() {
    const requiredOptions = mainElement.requiredOptions || [];
    return requiredOptions.length > 0;
  }

  function getRequiredMessage() {
    const label = mainElement.requiredOptions?.[0] || "";
    const firstLetter = label[0]?.toLowerCase() || "";
    const prep = "aeiou".includes(firstLetter) ? "an" : "a";
    const msgTemplate = lngg?.product_main__select_option_label || "Select a {{ option_name }}";
    return msgTemplate.replace("Select a ", `Select ${prep} `).replace(/{{ *option_name *}}/, label);
  }
});


document.addEventListener("DOMContentLoaded", function () {
  const mainElement = document.querySelector(".new-pdp-layout");
  if (!mainElement) return;

  const variantEdit = mainElement.querySelector("[data-variant-edit]");
  if (!variantEdit) return;

  const toggles = variantEdit.querySelectorAll(".toggle");
  const divVariants = variantEdit.querySelector(".variants");

  let editing = false;

  function expand(el) {
    el.style.display = "";
    el.style.height = "auto";
    el.style.overflow = "";
  }

  function collapse(el) {
    el.style.height = "0px";
    el.style.overflow = "hidden";
    el.style.display = "none";
  }

  toggles.forEach((btn) => {
    btn.addEventListener("click", () => {
      editing = !editing;
      if (editing) {
        expand(divVariants);
        toggles.forEach((btn) => btn.classList.add("open"));
      } else {
        collapse(divVariants);
        toggles.forEach((btn) => btn.classList.remove("open"));
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById('custom-size-dropdown');
  
  if (!container) return;

  const select = container.querySelector('select');
  
  if (!select) return;

  function updateCurrentSizeLabel() {
    const selectedOption = select.options[select.selectedIndex];
    const base = selectedOption.getAttribute('data-base-label') || selectedOption.value;
    container.querySelector('#current-size').textContent = base;
  }

  container.querySelector('#current-size').addEventListener('click', function () {
    select.focus();
    select.click();
    select.size = select.options.length;
    setTimeout(function () { select.size = 1; }, 300);
  });

  select.addEventListener('change', updateCurrentSizeLabel);
  select.addEventListener('blur', updateCurrentSizeLabel);

  updateCurrentSizeLabel();
});